import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TYPE, URL } from '../../../constant';

function ResultRecommend({ aiRecommList, lrnPrgsStsCd }) {
  const history = useHistory();
  const deviceType = useSelector(state => state.deviceInfo.type);

  const handleClick = useCallback((item) => {
    history.push(`${URL.TOPIC_LEARNING}/${item.thmaCd}`)
  }, []);

  return (
    <div className="AI_RcmdLning_wrap">
      <div className="Rcmd_tit">
        <span className="tit_blue">AI추천학습</span> <br />도움이 되는 학습이야. 한번 풀어볼까?
      </div>
      <div className="Rcmd_item_area">
        {
          (aiRecommList && aiRecommList.length > 0 ) && (
            aiRecommList.filter((item, index) => {
              
              if (deviceType === 'v-mob') {
                // index === 0 return은 모바일은 첫 추천학습은 제외
                if (lrnPrgsStsCd === TYPE.LRN_PRGS_STS_CD.LPSC01) {
                  if (index === 0) return false;
                  else return true;
                }else {
                  if (index <= 1) return true;
                  else return false
                }

              } else {
                return true; 
              }
            }).map((item, index) => {
              return (
                <div className="Rcmd_item" key={index} onClick={() => handleClick(item)}>
                  <img src={`${item.stgImgFilePath}${item.stgImgFileNm}`} alt="" />
                  <p className="sub_txt">{item.stgNm}</p>
                </div>
              )
            })
          )
        }
      </div>
    </div>
  );
}

export default ResultRecommend;